<script>
import { VSnackbar } from 'vuetify/lib'

export default {
  name: 'OfflineIndicator',
  data: () => ({
    online: navigator.onLine
  }),
  mounted () {
    window.addEventListener('online', () => this.setOnline())
    window.addEventListener('offline', () => this.setOnline())
  },
  methods: {
    setOnline (status) {
      this.online = status ?? navigator.onLine
    }
  },
  render (h) {
    return h(VSnackbar, {
      props: {
        color: 'error',
        bottom: true,
        timeout: 0,
        value: !this.online
      }
    }, 'Your internet connection is offline.')
  }
}
</script>
